import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import baseFirebaseConfig from '../firebase-applet-config.json';

// Resolve authDomain: use production custom domain when hosted on emr.allegianttherapy.com,
// and default Firebase authDomain (gen-lang-client-0595379473.firebaseapp.com) for preview/dev environments
// or fallback until the custom redirect URI is registered in Google Cloud Console.
const isProdHost = typeof window !== 'undefined' && (
  window.location.hostname === 'emr.allegianttherapy.com' ||
  window.location.hostname === 'allegianttherapy.com'
);

const defaultAuthDomain = 'gen-lang-client-0595379473.firebaseapp.com';

const runtimeConfig = {
  ...baseFirebaseConfig,
  // Note: custom domain emr.allegianttherapy.com requires https://emr.allegianttherapy.com/__/auth/handler
  // to be registered in Google Cloud Console OAuth Client (226059446802-8nuphg9v1sjbhi08vakq1sqovgof4d3q.apps.googleusercontent.com).
  // Until added in Cloud Console, defaultAuthDomain prevents redirect_uri_mismatch on all domains.
  authDomain: defaultAuthDomain
};

const app = getApps().length > 0 ? getApp() : initializeApp(runtimeConfig);
export const auth = getAuth(app);

export const googleProvider = new GoogleAuthProvider();
// Request Google account selection on every explicit sign-in click so users can choose their staff account.
// Do not enforce hd here; backend /api/auth/login provides authoritative server-side domain & roster validation.
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export { signInWithPopup, signOut };

